<template>
  <div>
    <v-container fluid class="card-flex-toolbar noPadding" scrollable style="width:100%;">

      <v-toolbar card prominent top offet-y v-bind:class="{'fixedToolbar' : !drawer}" style="z-index: 2;">
        <v-toolbar-title class="headline grey-text">Budgets</v-toolbar-title>
        <v-spacer></v-spacer>

        <v-tooltip left>
          <v-btn v-on:click.prevent="$router.push({ path: '/dashboard/addbudget' })"
                 slot="activator"
                 small
                 fab
                 flat
                 middle
                 right>
            <v-icon>fas fa-plus</v-icon>
          </v-btn>
          <span>Add Budget</span>
        </v-tooltip>

        <!--Speed Dial-->
        <v-speed-dial v-model="speedDial"
                      :direction="direction"
                      :transition="transition">
          <v-btn slot="activator"
                 v-model="speedDial"
                 flat
                 small
                 fab>
            <v-icon>fas fa-ellipsis-v</v-icon>
            <v-icon>fas fa-times</v-icon>
          </v-btn>

          <!-- Search Button -->
          <v-tooltip left>
            <v-btn v-on:click.prevent="viewSearch = !viewSearch"
                   slot="activator"
                   fab
                   small
                   middle
                   right>
              <v-icon>fas fa-search</v-icon>
            </v-btn>
            <span>Search</span>
          </v-tooltip>
          <!--End Of Search Button-->
          <!-- Filter Button -->
          <v-tooltip left>
            <v-btn v-on:click.prevent="viewFilter = !viewFilter"
                   slot="activator"
                   fab
                   small
                   middle
                   right>
              <v-icon>fas fa-filter</v-icon>
            </v-btn>
            <span>Filter</span>
          </v-tooltip>
          <!-- End Of Filter Button -->

        </v-speed-dial>
        <!--End Of Speed Dial-->

      </v-toolbar>

      <v-container fluid
                   style="min-height: 0;"
                   grid-list-lg
                   v-bind:class="{'padContent': !drawer}">
        <v-layout row wrap>

          <ListItem v-for="itemMinus in itemsMinusDeleted" v-bind:liItem="{type: 'budget',data: itemMinus}" :key="itemMinus.id" ref="listItem" v-on:Edit="redirectToEditPage($event)" v-on:Delete="DeleteBudget($event)"></ListItem>
        
        </v-layout>
      </v-container>

    </v-container>

    
      <!-- Delete Budget Dialog Box -->
      <v-layout row justify-center>
        <v-dialog v-model="deleteDialog" max-width="290">
          <v-card>
            <v-card-title class="headline">Delete</v-card-title>
            <v-card-text>Are you sure you want to delete <b>"{{deleteBudget.budgetName}}"</b>?</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" flat="flat" @click.native="deleteDialog = false">No</v-btn>
              <v-btn color="green darken-1" flat="flat" @click.native="DeleteBudgetAccept()">Yes</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
      <!-- End Of Delete Budget Dialog Box -->

</div>
</template>

<script>
  import { validationMixin } from 'vuelidate'
  import { required, minValue } from 'vuelidate/lib/validators'
  
  import listItem from '../reuseable/viewListItem/listItem.vue'

  export default {
    mixins: [validationMixin],
    components: {
      'ListItem': listItem
    },
    props: ['drawer'],
    data() {
      return {
        direction: 'left',
        speedDial: false,
        transition: 'slide-y-reverse-transition',
        moreOptions: false,
        search: '',
        viewSearch: false,
        viewFilter: false,  
        //rowsPerPageItems: [4, 8, 12],
        //pagination: {
        //  //rowsPerPage: 4
        //},
        account: [],
        category: ["cat1", "cat2", "cat3", "cat4"],
        type: ["None", "Weekly", "Monthly", "Yearly"],
        sameBudget: false,
        copyToRefill: true,
        //addDialog: false,
        //editDialog: false,
        deleteDialog: false,
        //addModelRefillDate: false,
        //editModelRefillDate: false,
        //currentBudget: {
        //  id: 0,
        //  budgetName: '',
        //  account: '',
        //  budgetType: '',
        //  budgetAmount: 0,
        //  amountSpent: 0,
        //  refillAmount: 0,
        //  //refillDate: '',
        //  comment: '',
        //  category: [],
          
        //  //Notification
        //  budgetOverspent: true,
        //  OverspendingRisk: true,

        //  //State of Current Object
        //  objectState: 'New'
        //},
        //editBudget: {
        //  id: 0,
        //  budgetName: '',
        //  account: '',
        //  budgetType: '',
        //  budgetAmount: 0,
        //  amountSpent: 0,
        //  refillAmount: 0,
        //  //refillDate: '',
        //  comment: '',
        //  category: '',

        //  //Notification
        //  budgetOverspent: true,
        //  OverspendingRisk: true,

        //  //State of Current Object
        //  objectState: ''
        //},
        deleteBudget: {
          id: 0,
          budgetName: '',
          account: '',
          budgetType: '',
          budgetAmount: 0,
          amountSpent: 0,
          refillAmount: 0,
          //refillDate: '',
          currency: '',
          comment: '',
          category: '',

          //Notification
          budgetOverspent: true,
          OverspendingRisk: true,

          //State of Current Object
          objectState: ''
        },
        items: [],
        itemsMinusDeleted: []
      }
    },
    computed: {
      //percentage: function () {
      //  return (spent, total) => {
      //    return (spent/total) * 100
      //  }
      //},
      //colorSelector: function () {
      //  return (val) => {
      //    if (val < 60) {
      //      return 'green'
      //    }
      //    else if (val >= 60 && val < 90) {
      //      return 'orange'
      //    }
      //    else if (val >= 90) {
      //      return 'red'
      //    }
      //  }
      //},
      pages() {
        if (this.pagination.rowsPerPage === null ||
          this.pagination.totalItems === null
        ) return 0

        return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
      },
      //budgetNameErrors() {
      //  const errors = []
      //  if (!this.$v.currentBudget.budgetName.$dirty && !this.$v.editBudget.budgetName.$dirty) return errors
      //  this.sameBudget && errors.push('A Budget already has this Name. Enter a new Name of update Budget')
      //  !this.$v.currentBudget.budgetName.required && !this.$v.editBudget.budgetName.required && errors.push('Budget Name is required')
      //  return errors
      //},
      //accountErrors() {
      //  const errors = []
      //  if (!this.$v.currentBudget.account.$dirty && !this.$v.editBudget.account.$dirty) return errors
      //  !this.$v.currentBudget.account.required && !this.$v.editBudget.account.required && errors.push('Account is required')
      //  return errors
      //},
      //budgetTypeErrors() {
      //  const errors = []
      //  if (!this.$v.currentBudget.budgetType.$dirty && !this.$v.editBudget.budgetType.$dirty) return errors
      //  !this.$v.currentBudget.budgetType.required && !this.$v.editBudget.budgetType.required && errors.push('Budget Type is required')
      //  return errors
      //},
      //categoryErrors() {
      //  const errors = []
      //  if (!this.$v.currentBudget.category.$dirty && !this.$v.editBudget.category.$dirty) return errors
      //  !this.$v.currentBudget.category.required && !this.$v.editBudget.category.required && errors.push('Category is required')
      //  return errors
      //},
      //budgetAmountErrors() {
      //  const errors = []
      //  if (!this.$v.currentBudget.budgetAmount.$dirty && !this.$v.editBudget.budgetAmount.$dirty) return errors
      //  !this.$v.currentBudget.budgetAmount.minValue && !this.$v.editBudget.budgetAmount.minValue && errors.push('Budget Amount must be at least 1')
      //  return errors
      //},
      //refillAmountErrors() {
      //  const errors = []
      //  if (!this.$v.currentBudget.budgetAmount.$dirty && !this.$v.editBudget.budgetAmount.$dirty) return errors
      //  !this.$v.currentBudget.budgetAmount.minValue && !this.$v.editBudget.budgetAmount.minValue && errors.push('Refill Amount must be at least 1')
      //  return errors
      //},
      //copyBudgetAmountToRefillAmount() {
      //  if (this.currentBudget.refillAmount === 0 || this.currentBudget.refillAmount === '' || this.editBudget.refillAmount === 0 || this.editBudget.refillAmount === '') {
      //    this.copyToRefill = true
      //  }

      //  if (this.copyToRefill === true) {
      //    this.currentBudget.refillAmount = this.currentBudget.budgetAmount
      //    this.editBudget.refillAmount = this.editBudget.budgetAmount
      //  }
       
      //},
      //stopCopyBudgetAmountToRefillAmount() {
      //  this.copyToRefill = false
      //}
    },
    methods: {
      //budgetCheck: function ($v) {
      //  $v.$touch(); //Triggers Error Messages

      //  if (this.currentBudget.budgetAmount <= 0 || !globalFunctions.isIntOrFloat(this.currentBudget.budgetAmount) || this.currentBudget.budgetAmount === "") { this.currentBudget.budgetAmount = 0 }

      //  if ($v.budgetName.$invalid || $v.account.$invalid) {
      //    return false
      //  }
        
      //  for (let i = 0; i < this.items.length; i++) {
      //    if (this.items[i].budgetName.toLowerCase() === this.currentBudget.budgetName.toLowerCase()) {
      //      this.sameBudget = true
      //      return false
      //    }
      //    if (i === this.items.length - 1) {
      //      this.sameBudget = false
      //    }
      //  }

      //  return true
      //},
      //AddBudgetCheck: function ($v) {
      //  if (this.budgetCheck($v)) {
      //    this.AddBudget($v);
      //  }
      //},
      //AddBudget: function ($v) {
      //  let newEntry = JSON.parse(JSON.stringify(this.currentBudget))

      //  this.addDialog = false

      //  newEntry.id = this.getLargestIdFromItems() + 1

      //  this.$store.commit('addNewBudgetToStore', newEntry)
      //  this.resetCurrentBudgetObject()

      //  $v.$reset() //Resets Validations
      //},
      //getLargestIdFromItems: function () {
      //  let largest = 0
      //  for (let i = 0; i < this.items.length; i++) {
      //    if (this.items[i].id > largest) {
      //      largest = this.items[i].id
      //    }
      //  }
      //  return largest
      //},
      UpdateEditedBudget: function ($v) {
        if (this.budgetCheck($v)) {
          this.editDialog = false

          this.editBudget.objectState = "Update"

          this.$store.commit('updateBudgetinStore', this.editBudget)
        }
      },
      EditBudget: function (item) {
        for (let i = 0; i < this.items.length; i++) {
          if (this.items[i].id === item) {
            let editEntry = JSON.parse(JSON.stringify(this.items[i]))
            this.editBudget = editEntry
            break
          }
        }

        this.editDialog = true
        this.copyToRefill = false
      },
      redirectToEditPage: function (item) {
        this.$router.push({ path: '/dashboard/editbudget/' + item })
      },
      DeleteBudgetAccept: function () {
        this.deleteDialog = false

        this.deleteBudget.objectState = "Delete"

        this.$store.commit('markBudgetAsDeleted', this.deleteBudget)
      },
      DeleteBudget: function (item) {

        for (let i = 0; i < this.items.length; i++) {
          if (this.items[i].id === item) {
            this.deleteBudget = this.items[i]
            break
          }
        }

        this.deleteDialog = true
      },
      resetCurrentBudgetObject: function (){
        this.currentBudget.budgetName= ''
        this.currentBudget.account= ''
        this.currentBudget.budgetType= ''
        this.currentBudget.budgetAmount= 0
        this.currentBudget.amountSpent= 0
        this.currentBudget.refillAmount = 0
        this.currentBudget.category = []
        this.currentBudget.comment= ''
        this.currentBudget.category= ''
        this.currentBudget.budgetOverspent= true
        this.currentBudget.OverspendingRisk= true
      },
      getitemsFromStoreAndRemoveDeletedItems: function () {
        this.items = JSON.parse(JSON.stringify(this.$store.state.Budgets))

        ///Remove deleted items from items array
        this.removeDeletedBudgetsFromItems()
      },
      removeDeletedBudgetsFromItems: function () {
        this.itemsMinusDeleted = JSON.parse(JSON.stringify(this.items))

        for (let i = 0; i < this.itemsMinusDeleted.length; i++) {
          if (this.itemsMinusDeleted[i].objectState === 'Delete') {
            this.itemsMinusDeleted.splice(i, 1)
          }
        }
      }
    },
    beforeMount() {
      this.getitemsFromStoreAndRemoveDeletedItems()

      let cat = this.$store.state.Categories
      for (let i = 0; i < cat.length; i++) {
        this.category.push(cat[i].categoryName)
      }

      let acc = this.$store.state.Accounts
      for (let i = 0; i < acc.length; i++) {
        this.account.push(acc[i].accountName)
      }
    },
    validations: {
      currentBudget: {
        budgetName: {
          required
        },
        account: {
          required
        },
        category: {
          required
        },
        budgetType: {
          required
        },
        budgetAmount: {
          required,
          minValue: minValue(1)
        },
        refillAmount: {
          required,
          minValue: minValue(1)
        },
        refillDate: {
          required
        }
      },
      editBudget: {
        budgetName: {
          required
        },
        account: {
          required
        },
        category: {
          required
        },
        budgetType: {
          required
        },
        budgetAmount: {
          required
        },
        refillAmount: {
          required,
          minValue: minValue(1)
        },
        refillDate: {
          required
        }
      }
    }
    

  }
</script>



// WEBPACK FOOTER //
// src/components/budget/ViewBudgets.vue